import React from "react";
import { REQ_ERR_MSG } from "../../Shared/Helper/ValidationMessage";

interface InputFiledProps {
  type: string;
  register: any;
  errors?: any;
  name: string;
  className?: string;
  placeholder?: string;
  required?: boolean;
  pattern?: {
    type: any;
    message: string;
  };
  value?: string;
  maxLength?: number;
  tabIndex?: number;
  autoFocus?: boolean;
  onChange?: any;
  defaultValue?: any;
  hidden?: boolean;
  disable?: boolean;
  onKeyDown?: (event: React.KeyboardEvent<HTMLInputElement>) => void;
  regex?: {
    pattern: RegExp;
    message: string;
  };
}
export default function InputFiled(props: InputFiledProps) {
  const {
    type,
    register,
    errors,
    name,
    className,
    placeholder,
    required = false,
    pattern,
    regex,
    maxLength,
    tabIndex,
    autoFocus = false,
    defaultValue,
    onChange,
    hidden,
    value,
    disable = false,
    onKeyDown,
  } = props;

  const [inputValue, setInputValue] = React.useState(value);
  const [regexError, setRegexError] = React.useState<string | null>(null);

  const handleOnChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = event.target.value;
    setInputValue(newValue);


    if (regex && newValue) {
      const isValid = regex.pattern.test(newValue);
      setRegexError(isValid ? null : regex.message);
    } else {
      setRegexError(null);
    }

    if (onChange) {
      onChange(event);
    }
  };

  const hasPatternError = errors?.type === "pattern";
  const hasRequiredError = errors?.type === "required";
  const hasError = hasPatternError || hasRequiredError || regexError;

  let inputClassName = className || "";
  if ((hasRequiredError && !inputValue) || hasPatternError || regexError) {
    inputClassName += " border-danger text-danger";
  }

  return (
    <>
      <input
        hidden={hidden}
        autoFocus={autoFocus}
        tabIndex={tabIndex}
        type={type}
        name={name}
        autoComplete="off"
        maxLength={maxLength}
        className={inputClassName}
        {...register(name, {
          ...(required && {
            required: {
              value: true,
              message: REQ_ERR_MSG,
            },
          }),
          ...(pattern && {
            pattern: {
              value: pattern.type,
              message: pattern.message,
            },
          }),
        })}
        onChange={handleOnChange}
        placeholder={placeholder}
        value={value}
        disabled={disable}
        onKeyDown={onKeyDown}
      />

      {hasError && (
        <div className="text-danger">
          {regexError || 
           (hasRequiredError && !inputValue && errors.message) || 
           (hasPatternError && errors.message)}
        </div>
      )}
    </>
  );
}
